import type { RowSkin } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

// One shared visual vocabulary for the protected preview leaf. Surfaces own
// the final RowSkin and may override any token, but spreading this block keeps
// the badge/form consistent across every creation and reading surface.
export const defaultBlockedPreviewSkin: RowSkin['blockedNotice'] = {
  root: 'inline-flex max-w-full align-middle',
  badge: 'inline-flex max-w-full items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-[12px] font-medium leading-4 text-amber-800',
  badgeButton: 'cursor-pointer transition-colors hover:border-amber-300 hover:bg-amber-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-1',
  badgeStatic: 'cursor-default',
  icon: 'flex-none text-[11px] leading-none',
  form: 'inline-flex max-w-full flex-wrap items-center gap-1.5',
  input: 'h-8 w-36 max-w-full rounded-md border border-slate-300 bg-white px-2.5 text-[13px] text-slate-900 outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-200 disabled:opacity-60',
  button: 'h-8 rounded-md border border-amber-300 bg-amber-50 px-3 text-[12px] font-semibold text-amber-900 transition-colors hover:bg-amber-100 disabled:cursor-wait disabled:opacity-60',
  error: 'text-[12px] font-medium text-red-600',
}
